import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.Linear_1 = new (Easing())(0.0, 0.0, 1.0, 1.0);
        this.EaseOut_1 = new (Easing())(0.0, 0.0, 0.58, 1.0);
        this.EaseIn_1 = new (Easing())(0.42, 0.0, 1.0, 1.0);
        this.EaseInOut_1 = new (Easing())(0.42, 0.0, 0.58, 1.0);
        this.Spring_1 = new (Easing())(0.175, 0.885, 0.32, 1.275);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var EasingClass;
function Easing() {
  if (EasingClass === VOID) {
    class $ {
      constructor(x1, y1, x2, y2) {
        Companion_getInstance();
        this.x1__1 = x1;
        this.y1__1 = y1;
        this.x2__1 = x2;
        this.y2__1 = y2;
      }
      toString() {
        return 'Easing(x1=' + this.x1__1 + ', y1=' + this.y1__1 + ', x2=' + this.x2__1 + ', y2=' + this.y2__1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.x1__1);
        result = imul(result, 31) + getNumberHashCode(this.y1__1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.x2__1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.y2__1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Easing()))
          return false;
        if (!equals(this.x1__1, other.x1__1))
          return false;
        if (!equals(this.y1__1, other.y1__1))
          return false;
        if (!equals(this.x2__1, other.x2__1))
          return false;
        if (!equals(this.y2__1, other.y2__1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Easing');
    EasingClass = $;
  }
  return EasingClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance29xhjtuiwkkzk,
};
//endregion

//# sourceMappingURL=Easing.mjs.map
